function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "career_upgrade",
  transform: "translate(-1200.496 -840)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5639",
  "data-name": "Rectangle 5639",
  width: 56,
  height: 56,
  transform: "translate(1200.496 840)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "graphic-presentation",
  transform: "translate(1206.946 846.333)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60980",
  "data-name": "Path 60980",
  d: "M36.657,5.278a5.193,5.193,0,0,0-5.193,5.193V35.019a5.193,5.193,0,0,0,10.386,0V10.471A5.193,5.193,0,0,0,36.657,5.278Z",
  transform: "translate(-3 1.455)",
  fill: "#ff0660",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Union_151",
  "data-name": "Union 151",
  d: "M-13079.235-4390.339a1.209,1.209,0,0,1-.273-1.7l.545-.737a40.118,40.118,0,0,1,15.556-12.606l-1.52-.864a1.208,1.208,0,0,1-.453-1.663,1.25,1.25,0,0,1,1.691-.446l4.041,2.3a1.208,1.208,0,0,1,.453,1.662l-2.335,3.978a1.248,1.248,0,0,1-1.688.446,1.2,1.2,0,0,1-.453-1.663l.751-1.28a37.646,37.646,0,0,0-14.041,11.572l-.545.736a1.247,1.247,0,0,1-1,.5A1.244,1.244,0,0,1-13079.235-4390.339Z",
  transform: "translate(13081.494 4412.188)",
  fill: "#ff0660"
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_61",
  "data-name": "Subtraction 61",
  d: "M22077.258,6724.086a4.7,4.7,0,0,1-4.693-4.694v-13.218a4.691,4.691,0,1,1,9.383,0v13.218A4.7,4.7,0,0,1,22077.258,6724.086Zm0-20.772a2.862,2.862,0,0,0-2.859,2.86v13.218a2.86,2.86,0,0,0,5.721,0v-13.218A2.863,2.863,0,0,0,22077.258,6703.314Zm-13.105,20.772a4.7,4.7,0,0,1-4.7-4.694v-1.89a4.694,4.694,0,1,1,9.389,0v1.89A4.7,4.7,0,0,1,22064.152,6724.086Zm0-9.444a2.866,2.866,0,0,0-2.865,2.86v1.89a2.862,2.862,0,0,0,5.725,0v-1.89A2.862,2.862,0,0,0,22064.152,6714.643Z",
  transform: "translate(-22057.707 -6682.917)",
  fill: "#000072"
})));

function SvgCareerUpgrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerUpgrade);
export default __webpack_public_path__ + "static/media/career_upgrade.e4897f6b.svg";
export { ForwardRef as ReactComponent };